// extracted by mini-css-extract-plugin
export default {"patreon":"Patreon_patreon__4FyEh"};